var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RoundedButton InterfaceElement"},[_vm._t("icon",[_vm._v("Icon")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }